export default __webpack_public_path__ + "291602659587b0c78cd2d3b09ace4516.png";